import { defineMessages } from 'react-intl';

export const discountCardCalculatorScope =
  'app.components.discountCardCalculator';

export const discountCardCalculatorMessages = {
  // Phrased as the question people type: it is the block search engines lift.
  title: {
    id: `${discountCardCalculatorScope}.title`,
    defaultMessage: 'La {card} est-elle rentable pour vous ?',
    en: 'Is the {card} worth it for you?',
    it: 'La {card} conviene per te?',
    es: '¿Te sale rentable la {card}?',
    de: 'Lohnt sich die {card} für Sie?',
    nl: 'Is de {card} voordelig voor jou?',
  },
  route: {
    id: `${discountCardCalculatorScope}.route`,
    defaultMessage: 'Votre trajet habituel',
    en: 'Your usual trip',
    it: 'Il tuo viaggio abituale',
    es: 'Tu trayecto habitual',
    de: 'Ihre übliche Strecke',
    nl: 'Je gebruikelijke traject',
  },
  roundTrips: {
    id: `${discountCardCalculatorScope}.roundTrips`,
    defaultMessage: 'Allers-retours par an',
    en: 'Return trips a year',
    it: "Viaggi di andata e ritorno all'anno",
    es: 'Viajes de ida y vuelta al año',
    de: 'Hin- und Rückfahrten pro Jahr',
    nl: 'Retourritten per jaar',
  },
  roundTripsUnit: {
    id: `${discountCardCalculatorScope}.roundTripsUnit`,
    defaultMessage: 'allers-retours par an',
    en: 'return trips a year',
    it: "andata e ritorno all'anno",
    es: 'idas y vueltas al año',
    de: 'Hin- und Rückfahrten pro Jahr',
    nl: 'retourritten per jaar',
  },
  booking: {
    id: `${discountCardCalculatorScope}.booking`,
    defaultMessage: 'Je réserve',
    en: 'I book',
    it: 'Prenoto',
    es: 'Reservo',
    de: 'Ich buche',
    nl: 'Ik boek',
  },
  bookingUnknown: {
    id: `${discountCardCalculatorScope}.bookingUnknown`,
    defaultMessage: 'Je ne sais pas',
    en: "I don't know",
    it: 'Non lo so',
    es: 'No lo sé',
    de: 'Weiß ich nicht',
    nl: 'Weet ik niet',
  },
  bookingDays: {
    id: `${discountCardCalculatorScope}.bookingDays`,
    defaultMessage:
      '{days, select, 1 {La veille} 7 {1 semaine avant} 14 {2 semaines avant} 30 {1 mois avant} 60 {2 mois avant} other {{days} jours avant}}',
    en: '{days, select, 1 {The day before} 7 {1 week ahead} 14 {2 weeks ahead} 30 {1 month ahead} 60 {2 months ahead} other {{days} days ahead}}',
    it: '{days, select, 1 {Il giorno prima} 7 {1 settimana prima} 14 {2 settimane prima} 30 {1 mese prima} 60 {2 mesi prima} other {{days} giorni prima}}',
    es: '{days, select, 1 {El día antes} 7 {1 semana antes} 14 {2 semanas antes} 30 {1 mes antes} 60 {2 meses antes} other {{days} días antes}}',
    de: '{days, select, 1 {Am Vortag} 7 {1 Woche vorher} 14 {2 Wochen vorher} 30 {1 Monat vorher} 60 {2 Monate vorher} other {{days} Tage vorher}}',
    nl: '{days, select, 1 {De dag ervoor} 7 {1 week vooraf} 14 {2 weken vooraf} 30 {1 maand vooraf} 60 {2 maanden vooraf} other {{days} dagen vooraf}}',
  },
  accompanied: {
    id: `${discountCardCalculatorScope}.accompanied`,
    defaultMessage: 'Accompagné d’un adulte ?',
    en: 'Travelling with another adult?',
    it: 'Accompagnato da un adulto?',
    es: '¿Acompañado de un adulto?',
    de: 'Mit einem anderen Erwachsenen?',
    nl: 'Samen met een andere volwassene?',
  },
  weekendOrChild: {
    id: `${discountCardCalculatorScope}.weekendOrChild`,
    defaultMessage: 'Le week-end ou avec un enfant ?',
    en: 'On a weekend or with a child?',
    it: 'Nel fine settimana o con un bambino?',
    es: '¿En fin de semana o con un niño?',
    de: 'Am Wochenende oder mit Kind?',
    nl: 'In het weekend of met een kind?',
  },
  weekendOrChildHint: {
    id: `${discountCardCalculatorScope}.weekendOrChildHint`,
    defaultMessage:
      'Un aller-retour avec une nuit du vendredi, samedi ou dimanche, un aller simple le week-end, ou un trajet avec un enfant de moins de 12 ans.',
    en: 'A return trip including a Friday, Saturday or Sunday night, a single trip at the weekend, or a trip with a child under 12.',
    it: 'Un andata e ritorno con una notte di venerdì, sabato o domenica, una sola andata nel fine settimana o un viaggio con un bambino sotto i 12 anni.',
    es: 'Una ida y vuelta con una noche de viernes, sábado o domingo, una ida en fin de semana o un trayecto con un niño menor de 12 años.',
    de: 'Eine Hin- und Rückfahrt mit einer Nacht von Freitag, Samstag oder Sonntag, eine einfache Fahrt am Wochenende oder eine Fahrt mit einem Kind unter 12.',
    nl: 'Een retour met een nacht van vrijdag, zaterdag of zondag, een enkele reis in het weekend of een rit met een kind onder de 12.',
  },
  NEVER: {
    id: `${discountCardCalculatorScope}.NEVER`,
    defaultMessage: 'Non',
    en: 'No',
    it: 'No',
    es: 'No',
    de: 'Nein',
    nl: 'Nee',
  },
  SOMETIMES: {
    id: `${discountCardCalculatorScope}.SOMETIMES`,
    defaultMessage: 'Parfois',
    en: 'Sometimes',
    it: 'A volte',
    es: 'A veces',
    de: 'Manchmal',
    nl: 'Soms',
  },
  ALWAYS: {
    id: `${discountCardCalculatorScope}.ALWAYS`,
    defaultMessage: 'Oui',
    en: 'Yes',
    it: 'Sì',
    es: 'Sí',
    de: 'Ja',
    nl: 'Ja',
  },
  medianPrice: {
    id: `${discountCardCalculatorScope}.medianPrice`,
    defaultMessage: 'Prix médian {origin} → {destination}{when} : {price}',
    en: 'Median price {origin} → {destination}{when}: {price}',
    it: 'Prezzo mediano {origin} → {destination}{when}: {price}',
    es: 'Precio mediano {origin} → {destination}{when}: {price}',
    de: 'Medianpreis {origin} → {destination}{when}: {price}',
    nl: 'Mediaanprijs {origin} → {destination}{when}: {price}',
  },
  medianWhen: {
    id: `${discountCardCalculatorScope}.medianWhen`,
    defaultMessage: ' à J-{days}',
    en: ' {days} days ahead',
    it: ' a {days} giorni',
    es: ' a {days} días',
    de: ' {days} Tage vorher',
    nl: ' {days} dagen vooraf',
  },
  withCard: {
    id: `${discountCardCalculatorScope}.withCard`,
    defaultMessage: 'avec la carte : {discounted}',
    en: 'with the card: {discounted}',
    it: 'con la carta: {discounted}',
    es: 'con la tarjeta: {discounted}',
    de: 'mit der Karte: {discounted}',
    nl: 'met de kaart: {discounted}',
  },
  loadingPrice: {
    id: `${discountCardCalculatorScope}.loadingPrice`,
    defaultMessage: 'On cherche le prix de ce trajet…',
    en: 'Looking up the price of this trip…',
    it: 'Cerchiamo il prezzo di questo viaggio…',
    es: 'Buscamos el precio de este trayecto…',
    de: 'Wir suchen den Preis dieser Strecke…',
    nl: 'We zoeken de prijs van dit traject…',
  },
  noPrice: {
    id: `${discountCardCalculatorScope}.noPrice`,
    defaultMessage:
      'On n’a pas encore assez de prix sur {origin} → {destination} pour estimer vos économies. Essayez un trajet proche.',
    en: 'We do not have enough prices on {origin} → {destination} yet to estimate your savings. Try a nearby trip.',
    it: 'Non abbiamo ancora abbastanza prezzi su {origin} → {destination} per stimare il tuo risparmio. Prova una tratta vicina.',
    es: 'Aún no tenemos suficientes precios en {origin} → {destination} para estimar tu ahorro. Prueba un trayecto cercano.',
    de: 'Für {origin} → {destination} haben wir noch nicht genug Preise, um Ihre Ersparnis zu schätzen. Versuchen Sie eine Strecke in der Nähe.',
    nl: 'We hebben nog niet genoeg prijzen op {origin} → {destination} om je besparing te schatten. Probeer een traject in de buurt.',
  },
  pickCities: {
    id: `${discountCardCalculatorScope}.pickCities`,
    defaultMessage:
      'Choisissez vos villes de départ et d’arrivée dans la liste.',
    en: 'Pick your departure and arrival cities from the list.',
    it: 'Scegli le città di partenza e di arrivo dall’elenco.',
    es: 'Elige tus ciudades de salida y llegada en la lista.',
    de: 'Wählen Sie Ihre Abfahrts- und Ankunftsstadt aus der Liste.',
    nl: 'Kies je vertrek- en aankomststad uit de lijst.',
  },
  howWeCompute: {
    id: `${discountCardCalculatorScope}.howWeCompute`,
    defaultMessage: 'Comment on calcule',
    en: 'How we work it out',
    it: 'Come calcoliamo',
    es: 'Cómo lo calculamos',
    de: 'So rechnen wir',
    nl: 'Zo rekenen we',
  },
  moreInfo: {
    id: `${discountCardCalculatorScope}.moreInfo`,
    defaultMessage: 'Plus d’informations',
    en: 'More information',
    it: 'Maggiori informazioni',
    es: 'Más información',
    de: 'Mehr Informationen',
    nl: 'Meer informatie',
  },
  profitable: {
    id: `${discountCardCalculatorScope}.profitable`,
    defaultMessage: '{net} économisés par an, carte payée',
    en: '{net} saved a year, card paid for',
    it: "{net} risparmiati all'anno, carta pagata",
    es: '{net} ahorrados al año, tarjeta pagada',
    de: '{net} pro Jahr gespart, Karte bezahlt',
    nl: '{net} per jaar bespaard, kaart betaald',
  },
  notProfitable: {
    id: `${discountCardCalculatorScope}.notProfitable`,
    defaultMessage: 'Pas encore rentable : il manque {missing}',
    en: 'Not worth it yet: {missing} short',
    it: 'Non ancora conveniente: mancano {missing}',
    es: 'Aún no es rentable: faltan {missing}',
    de: 'Noch nicht rentabel: es fehlen {missing}',
    nl: 'Nog niet voordelig: er ontbreekt {missing}',
  },
  breakEven: {
    id: `${discountCardCalculatorScope}.breakEven`,
    defaultMessage:
      'Rentabilisée dès {trips, plural, one {le premier trajet} other {le #e trajet}}.',
    en: 'Pays for itself from {trips, plural, one {the first trip} other {trip number #}}.',
    it: 'Si ripaga dal {trips, plural, one {primo viaggio} other {#° viaggio}}.',
    es: 'Amortizada desde {trips, plural, one {el primer trayecto} other {el trayecto n.º #}}.',
    de: 'Rentabel ab {trips, plural, one {der ersten Fahrt} other {der #. Fahrt}}.',
    nl: 'Terugverdiend vanaf {trips, plural, one {de eerste rit} other {de #e rit}}.',
  },
  buy: {
    id: `${discountCardCalculatorScope}.buy`,
    defaultMessage: 'Acheter ma {card} – {price}',
    en: 'Buy my {card} – {price}',
    it: 'Acquista la mia {card} – {price}',
    es: 'Comprar mi {card} – {price}',
    de: 'Meine {card} kaufen – {price}',
    nl: 'Mijn {card} kopen – {price}',
  },
  rules: {
    id: `${discountCardCalculatorScope}.rules`,
    defaultMessage:
      'Prix médian des billets SNCF relevés sur Tictactrip. Calcul sur les règles SNCF hors promotions : -30 % sur les TGV INOUI et INTERCITÉS, et prix plafonnés en 2de classe à 49 € (moins de 1 h 30), 69 € (1 h 30 à 3 h) et 89 € (plus de 3 h). « Parfois » compte la moitié des trajets. Hors réductions TER et enfants.',
    en: 'Median price of the SNCF tickets seen on Tictactrip. Worked out on SNCF rules outside promotions: 30% off TGV INOUI and INTERCITÉS, and 2nd class prices capped at €49 (under 1h30), €69 (1h30 to 3h) and €89 (over 3h). "Sometimes" counts half of the trips. TER and child discounts not included.',
    it: 'Prezzo mediano dei biglietti SNCF rilevati su Tictactrip. Calcolo sulle regole SNCF senza promozioni: -30% sui TGV INOUI e INTERCITÉS, e prezzi massimi in 2ª classe di 49 € (meno di 1h30), 69 € (da 1h30 a 3h) e 89 € (più di 3h). «A volte» conta metà dei viaggi. Sconti TER e bambini esclusi.',
    es: 'Precio mediano de los billetes SNCF registrados en Tictactrip. Cálculo según las reglas de la SNCF sin promociones: -30 % en TGV INOUI e INTERCITÉS, y precios máximos en 2.ª clase de 49 € (menos de 1h30), 69 € (de 1h30 a 3h) y 89 € (más de 3h). «A veces» cuenta la mitad de los trayectos. Sin descuentos TER ni de niños.',
    de: 'Medianpreis der auf Tictactrip erfassten SNCF-Tickets. Berechnet nach den SNCF-Regeln ohne Aktionen: -30 % auf TGV INOUI und INTERCITÉS, Höchstpreise in der 2. Klasse von 49 € (unter 1:30 Std.), 69 € (1:30 bis 3 Std.) und 89 € (über 3 Std.). „Manchmal“ zählt die Hälfte der Fahrten. Ohne TER- und Kinderermäßigungen.',
    nl: 'Mediaanprijs van de SNCF-tickets gezien op Tictactrip. Berekend volgens de SNCF-regels zonder acties: -30% op TGV INOUI en INTERCITÉS, en maximumprijzen in 2e klas van €49 (minder dan 1u30), €69 (1u30 tot 3u) en €89 (meer dan 3u). "Soms" telt de helft van de ritten. Zonder TER- en kinderkortingen.',
  },
  liberteRules: {
    id: `${discountCardCalculatorScope}.liberteRules`,
    defaultMessage:
      'Pour la Carte Liberté, seul le tarif Avantage (week-end ou avec un enfant) est compté. En semaine, ses tarifs fixes, échangeables et remboursables sans frais, font économiser davantage : jusqu’à -60 % en 2de classe sur la base du tarif Flex Première.',
    en: 'For the Carte Liberté, only its tarif Avantage (weekend or with a child) is counted. On weekdays its fixed fares, exchangeable and refundable free of charge, save more: up to 60% off in 2nd class, based on the Flex Première fare.',
    it: 'Per la Carte Liberté conta solo la tariffa Avantage (fine settimana o con un bambino). In settimana le sue tariffe fisse, cambiabili e rimborsabili senza costi, fanno risparmiare di più: fino al -60% in 2ª classe sulla base della tariffa Flex Première.',
    es: 'Para la Carte Liberté solo se cuenta su tarifa Avantage (fin de semana o con un niño). Entre semana, sus tarifas fijas, cambiables y reembolsables sin gastos, ahorran más: hasta -60 % en 2.ª clase sobre la tarifa Flex Première.',
    de: 'Bei der Carte Liberté zählt nur der Tarif Avantage (Wochenende oder mit Kind). Unter der Woche sparen ihre festen, kostenlos umtausch- und erstattbaren Tarife mehr: bis zu -60 % in der 2. Klasse auf Basis des Flex-Première-Tarifs.',
    nl: 'Voor de Carte Liberté telt alleen het tarief Avantage (weekend of met een kind). Doordeweeks besparen de vaste tarieven, gratis om te ruilen en terug te betalen, meer: tot -60% in 2e klas op basis van het Flex Première-tarief.',
  },
};

export default defineMessages(discountCardCalculatorMessages);
